module.exports = __webpack_public_path__ + "static/img/slide-big2.418e85b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide-big2.jpg
// module id = 730
// module chunks = 1